import React, { useState, useEffect } from "react";
import DataKota from "./dumy/dataKota";
import { useTranslation } from "react-i18next";
import axios from "axios";

const SectionTableMaps = () => {
    const { t } = useTranslation();
    const [filteredKota, setFilteredKota] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchApiKdeks = async () => {
            try {
                const url = process.env.REACT_APP_API_URLKDEKS || "";
                const response = await axios.get(`${url}/api_maps_kdeks`);

                if (response.data && response.data.success) {
                    const apiData = response.data.data;
                    const allKota = DataKota();

                    // Filter allKota based on province_name present in the API response
                    // and only those that have image/data (matching map highlighting logic)
                    const initialMatches = [];
                    allKota.forEach((kota) => {
                        const match = apiData.find(
                            (apiProv) =>
                                apiProv.province_name.toLowerCase().trim() ===
                                kota.title.toLowerCase().trim()
                        );
                        if (match) {
                            initialMatches.push({
                                ...kota,
                                ...match
                            });
                        }
                    });

                    // Fetch the 'officials' data which is inside the specific detail endpoint
                    const result = await Promise.all(
                        initialMatches.map(async (item) => {
                            let pejabat = "";
                            try {
                                const detailResponse = await axios.get(`${url}/api_about_province_kdeks/${item.id_province}`);
                                if (detailResponse.data && detailResponse.data.length > 0) {
                                    pejabat = detailResponse.data[0].officials || "";
                                }
                            } catch (e) {
                                // Ignore errors to allow other regions to load
                            }
                            return {
                                ...item,
                                pejabat
                            };
                        })
                    );

                    setFilteredKota(result);
                }
            } catch (err) {
                console.error("Error fetching KDEKS API:", err);
                setFilteredKota([]);
            } finally {
                setLoading(false);
            }
        };

        fetchApiKdeks();
    }, []);

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // tableRows is no longer needed since we are displaying a single vertical list

    const handleKotaClick = (kota) => {
        if (!kota) return;
        const mapSection = document.querySelector(".mayor-section-maps");
        if (mapSection) {
            mapSection.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        setTimeout(() => {
            document.querySelectorAll(".maps-indo g").forEach((el) => {
                if (el.hasAttribute("data-original-fill")) {
                    el.setAttribute("fill", el.getAttribute("data-original-fill"));
                }
            });

            const mapArea = document.querySelector(
                `.maps-indo a[title="${kota.title}"], .maps-indo a[data-bs-original-title="${kota.title}"]`,
            );
            if (mapArea) {
                const g = mapArea.querySelector("g");
                if (g) {
                    if (!g.hasAttribute("data-original-fill")) {
                        g.setAttribute("data-original-fill", g.getAttribute("fill"));
                    }
                    g.setAttribute("fill", "#ffc107");
                }

                try {
                    if (window.bootstrap && window.bootstrap.Tooltip) {
                        document
                            .querySelectorAll('.maps-indo a[data-bs-toggle="tooltip"]')
                            .forEach((el) => {
                                const inst = window.bootstrap.Tooltip.getInstance(el);
                                if (inst) inst.hide();
                            });
                        let tooltip = window.bootstrap.Tooltip.getInstance(mapArea);
                        if (!tooltip) {
                            tooltip = new window.bootstrap.Tooltip(mapArea);
                        }
                        tooltip.show();
                    }
                } catch (e) { }
            }
        }, 300);
    };

    return (
        <section className="about-one-section-kdeks pb-5 pt-3">
            <div className="container">
                <table
                    className="table table-bordered text-start align-middle"
                    style={{ borderColor: "#dee2e6" }}
                >
                    <thead className="table-light">
                        <tr>
                            <th
                                colSpan="3"
                                className="fs-5 py-3 text-center"
                                style={{
                                    color: "#333",
                                    backgroundColor: "#f8f9fa",
                                    borderBottom: "2px solid #ddd",
                                }}
                            >
                                {t("daftarWilayah")}
                            </th>
                        </tr>
                        <tr>
                            <th
                                className="fs-6 py-3 text-center"
                                style={{
                                    color: "#333",
                                    backgroundColor: "#f8f9fa",
                                    borderBottom: "2px solid #ddd",
                                    width: "10%"
                                }}
                            >
                                No.
                            </th>
                            <th
                                className="fs-6 py-3 text-center"
                                style={{
                                    color: "#333",
                                    backgroundColor: "#f8f9fa",
                                    borderBottom: "2px solid #ddd",
                                    width: "45%"
                                }}
                            >
                                {t("wilayah")}
                            </th>
                            <th
                                className="fs-6 py-3 text-center"
                                style={{
                                    color: "#333",
                                    backgroundColor: "#f8f9fa",
                                    borderBottom: "2px solid #ddd",
                                    width: "45%"
                                }}
                            >
                                {t("pejabat")}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredKota.map((item, index) => (
                            <tr
                                key={index}
                                style={{ cursor: "pointer", transition: "0.2s" }}
                                onClick={() => handleKotaClick(item)}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "#e9ecef";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "";
                                }}
                            >
                                <td className="text-center fw-medium text-dark align-middle">
                                    {index + 1}
                                </td>
                                <td className="fw-medium text-dark align-middle ps-4">
                                    {item.title}
                                </td>
                                <td className="text-muted align-middle ps-4">
                                    {item.pejabat || "-"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default SectionTableMaps;
